import React, { useEffect } from 'react';
import './ExpiredRegistrationToken.css';
import headerImage from '../../assets/header.jpg';

const ExpiredRegistrationToken = () => {
  useEffect(() => {
    document.title = 'LeapFrog Lab Registration Admin Portal';
  }, []);

  return (
    <div className="expired-registration-token-page">
      <img src={headerImage} alt="Header" className="header-image" />
      <h1>LeapFrog Lab Registration</h1>
      <h2 className="h2">Expired Registration Token</h2>
      <div className="expired-registration-token-container">
        <div className="exclamation-mark">!</div>
        <div className="expired-guid-text">
          <strong>Oops!</strong>
          <p>
            The registration token for the account you are attempting to access
            has expired.
          </p>
          <p>
            Please send an email to{' '}
            <a href="mailto:leapfroglab@leapfrog.com">
              leapfroglab@leapfrog.com
            </a>{' '}
            including your Registration Email and ZipCode, and we will get back
            at the earliest possible time. Thank you!{' '}
          </p>
        </div>
      </div>
      <footer>
        <a
          href="https://www.leapfrog.com/en-us/legal/privacy"
          className="privacy-link"
        >
          Privacy Policy
        </a>
        <div className="copyright">
          Copyright © 2001 - 2024 LeapFrog Enterprises, Inc. All rights
          reserved.
        </div>
      </footer>
    </div>
  );
};

export default ExpiredRegistrationToken;
